import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SportProvider } from './contexts/SportContext';
import { EventProvider } from './contexts/EventContext';
import { NotificationProvider } from './contexts/NotificationContext';
import './i18n'; // NEU: Importiere die Sprachkonfiguration

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback="Loading...">
      <BrowserRouter>
        <AuthProvider>
          <SportProvider>
            <NotificationProvider>
              <EventProvider>
                <App />
              </EventProvider>
            </NotificationProvider>
          </SportProvider>
        </AuthProvider>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
);
